import { Navigate, Outlet, useLocation } from 'react-router';

import { LoadingState } from '@shared/ui/states';
import { useMustChangePassword, useSessionStatus } from '@shared/session/use-session';

export const LOGIN_PATH = '/acceso';
export const CHANGE_PASSWORD_PATH = '/cambiar-contrasena';

/**
 * Exige sesion para entrar en la aplicacion.
 *
 * Distingue tres estados, no dos. Mientras la sesion es `desconocida` la
 * aplicacion todavia esta comprobando la cookie: tratar ese instante como
 * "anonimo" mandaria al login a alguien que si tiene sesion, y el parpadeo se
 * veria en cada recarga.
 */
export function RequireAuth() {
  const status = useSessionStatus();
  const mustChangePassword = useMustChangePassword();
  const location = useLocation();

  if (status === 'desconocida') {
    return <LoadingState label="Comprobando la sesion" />;
  }

  if (status === 'anonima') {
    // Se recuerda a donde iba para devolverlo alli despues de entrar: perder
    // el destino obliga a repetir la navegacion cada vez que caduca la sesion.
    return <Navigate to={LOGIN_PATH} replace state={{ from: location.pathname }} />;
  }

  // Una contrasena temporal ha viajado por un canal externo -un chat, una
  // llamada- y no puede quedar vigente. El servidor ya restringe esta sesion
  // a cambiarla; aqui se replica para no ensenar pantallas que devolverian
  // 403 nada mas abrirlas.
  if (mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }

  return <Outlet />;
}
